import PricingComponent from "../components/pricingcomponents/pricingcomponent"

const PricingPage = ()=>{
    return(
       <PricingComponent/>
    )
}

export default PricingPage